module.exports = __webpack_public_path__ + "media/images/socials/facebook-23438fab0bcc0f54563189a082e420a8.png";